import { useState, useEffect } from "react";
import { Form, Input, Select, Upload, Button, Breadcrumb, message } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";
import { convertIntoFormData } from "../../../utils/utils";
import { useSelector } from "react-redux";


const { Option } = Select;

const CreateTicket = () => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const com_id = useSelector((store) => store.auth.userInfo.company_id);
  const comp_id = Number(localStorage.getItem('companyId')) || com_id;
  const navigate = useNavigate();

  // values.file = { fileList: [ { originFileObj: values.attachments?.fileList[0]?.originFileObj } ] }
  const onFinish = async (values) => {
    try {
      values.file = values.attachments?.fileList?.[0]?.originFileObj || null
      delete values.attachments;
      const formData = convertIntoFormData(values)
      formData.append("company_id", comp_id); // Append company ID to form data
      setIsLoading(true)
      const response = await axiosInstance.post(`/create-ticket/`, formData)
      console.log(response)
      if (response.status == 200) {
        form.resetFields();
        message.success(response.data.message);
        navigate(-1);
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      console.error("Error create tickets:", error);
      message.error(error?.response?.data?.error);

    } finally {
      setIsLoading(false);
    }
  };


  return (
    <>
      <div className="sticky -top-6 border-b bg-white dark:bg-[#17153B] z-10 shadow-sm p-3">
        <Breadcrumb className="font-medium text-gray-700 text-[14px]">
          <Breadcrumb.Item>
            <Link to="/admin/support" className="hover:text-blue-600 transition-colors">
              Support Dashboard
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item className="text-blue-500 font-semibold">Add Ticket</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <div className="bg-white border dark:bg-[#17153B] px-3 pt-3 mt-3 shadow-lg rounded-xl max-w-3xl mx-auto">
        <h2 className="text-[15px] font-semibold text-gray-800 dark:text-gray-200 text-center mb-1">Create New Ticket</h2>

        <Form  form={form} layout="vertical" onFinish={onFinish}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4">

          <Form.Item
            name="subject"
            label={"Subject"}
            rules={[{ required: true, message: "Enter subject" }]}
          >
            <Input placeholder="Enter subject" className="h-8 rounded-md focus:ring focus:ring-blue-200" />
          </Form.Item>

          <Form.Item
            name="subject_type"
            label={"Type"}
            rules={[{ required: true, message: "Select type" }]}
          >
            <Select className="w-full h-8 rounded-md focus:ring focus:ring-blue-200">
              <Option value="Query">Query</Option>
              <Option value="Issue">Issue</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="description"
            label="Description"
            rules={[{ required: true, message: "Enter description" }]}
            className="md:col-span-2"
          >
            <Input.TextArea rows={5} placeholder="Enter description..." />
          </Form.Item>

          <Form.Item
            name="attachments"
            label={"Attachments"}
            className="md:col-span-2"
          >
            <Upload.Dragger
              name="file"
              multiple={false}
              maxCount={1}
              showUploadList={{ showRemoveIcon: false }}
              className="rounded-md transition-all"
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined className="text-3xl text-blue-500" />
              </p>
              <p className="text-gray-600">
                Drop a file here or <span className="text-blue-500 font-medium">Browse</span> (Up to 20 MB)
              </p>
            </Upload.Dragger>
          </Form.Item>
          </div>
          <Form.Item className="flex justify-center">
            <Button
              type="primary"
              htmlType="submit"
              className="px-6 text-lg font-semibold rounded-lg 
              bg-gradient-to-r from-blue-500 to-indigo-600 text-white 
              hover:from-blue-600 hover:to-indigo-700 shadow-md transition-all 
              h-auto min-h-[40px]" // Ensure proper auto height
              disabled={isLoading} // Disable button when loading
              loading={isLoading} // Show loading spinner
            >
              {isLoading ? "Processing..." : "Create Ticket"}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};

export default CreateTicket;
